const initState = {
  category: [],
};
const FETCH_CATEGORY = "fetch_categoy";
export const fetchCategory = (payload) => ({
  type: FETCH_CATEGORY,
  payload,
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CATEGORY: {
        console.log(payload)
      return {
        ...state,
        category: [...payload],
      };
    }
    default:
      return state;
  }
};
